import { Button, Checkbox, Form, Input, Modal } from 'antd';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import ExclamationIcon from 'assets/icons/exclamation-triangle-fill.svg';
import { MasterSubCategory, MasterSubCategoryData } from 'domain/entities/MasterEntity';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { setVisibleCU03603 } from 'presentation/redux/features/CU/CU03603Slice';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

interface props {
    open: boolean;
    masterUseCase: MasterUseCaseInterface;
    propertyUseCase: PropertyUseCaseInterface;
}

const CODE_REASON_FOR_CANCEL_SALE = '0000000151';
const CODE_OTHER = '99';

export const CU036003Modal = ({ open, masterUseCase, propertyUseCase }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { registeredId } = useParams();

    const [listCategory, setListCategory] = useState<MasterSubCategory[]>([]);
    const [listChecked, setListChecked] = useState<any[]>([]);
    useEffect(() => {
        (async () => {
            try {
                dispatch(startFetching());
                const response: MasterSubCategoryData =
                    await masterUseCase.getMasterSubCategoryList({
                        categoryCode: CODE_REASON_FOR_CANCEL_SALE,
                    });
                if (response.result) setListCategory(response.result);
            } catch (error: any) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        })();
    }, []);
    const onChange = (checkedValues: any[]) => {
        setListChecked(checkedValues);
        if (!checkedValues.includes(CODE_OTHER)) form.validateFields(['reason']);
    };

    const submit = async (value: any) => {
        const foundCodeOther = listChecked?.includes(CODE_OTHER);
        const valueCheckbox = value.checkboxGroup?.toString().replaceAll(',', '|');
        dispatch(setVisibleCU03603());
        try {
            dispatch(startFetching());
            if (!registeredId) return;

            const response = await propertyUseCase.putEvictionListedProperty({
                listedPropertyId: +registeredId,
                inquiryContents01: valueCheckbox,
                inquiryContents02: foundCodeOther ? value.reason : '',
            });
            if (response.status === '200') {
                openSuccessNoti();
                form.resetFields();
                navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.DASHBOARD);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onCancel = () => {
        dispatch(setVisibleCU03603());
        form.resetFields();
    };

    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={ExclamationIcon} alt="" />
                </div>
                <div className="description-modal" style={{ marginBottom: 32, marginTop: 32 }}>
                    出品しない理由を選択してください。
                </div>
                <Form form={form} id="form-modal" onFinish={(value) => submit(value)}>
                    <div className="checkbox-wrapper" style={{ minHeight: 112 }}>
                        <Form.Item
                            name="checkboxGroup"
                            rules={[
                                {
                                    required: true,
                                    message: '理由を選択してください。',
                                },
                            ]}
                        >
                            <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                    {listCategory.map((element: MasterSubCategory) => (
                                        <div
                                            style={{
                                                display: 'flex',
                                                width: 279,
                                                height: 24,
                                                alignItems: 'center',
                                                gap: 8,
                                            }}
                                            key={element.id}
                                        >
                                            <Checkbox
                                                value={element.code}
                                                className="text-checkbox red-checkbox"
                                            >
                                                {element.codeName}
                                            </Checkbox>
                                        </div>
                                    ))}
                                </div>
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                    <div style={{ width: 279, height: 40 }}>
                        <Form.Item
                            name="reason"
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (listChecked?.includes(CODE_OTHER) && !value) {
                                            return Promise.reject(
                                                new Error(
                                                    getMessage('In_Required', 'その他の理由'),
                                                ),
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input
                                placeholder={PLACEHOLDER.TEXT}
                                style={{ height: 40 }}
                                disabled={!listChecked?.includes(CODE_OTHER)}
                            />
                        </Form.Item>
                    </div>

                    <div
                        className="description-warning"
                        style={{ marginBottom: 32, marginTop: 32 }}
                    >
                        改めて出品する場合は再度出品手続きが必要です。
                    </div>
                    <Button
                        className="text-button-ok"
                        type="primary"
                        danger
                        style={{ width: '100%', height: 48, background: '#B52A21' }}
                        htmlType="submit"
                    >
                        出品しない
                    </Button>
                    <Button
                        type="link"
                        block
                        className="text-button-cancel"
                        style={{ width: '100%', height: 48, marginTop: 12 }}
                        onClick={() => onCancel()}
                    >
                        キャンセル
                    </Button>
                </Form>
            </section>
        </Modal>
    );
};
